import React from "react";
import { UserPlus, UserCheck, AlertTriangle } from "lucide-react";

const digits = (s) => String(s || "").replace(/\D/g, "").replace(/^62/, "0").slice(-9);

export const MqCustomerStatus = ({ mq, customers, onPick, onAdd }) => {
  if (mq.customer_id) {
    const c = customers.find((x) => x.id === mq.customer_id);
    return <div className="flex items-center gap-2 text-xs text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2" data-testid="mq-cust-linked"><UserCheck className="w-4 h-4" /> Terhubung ke customer CRM{c?.code ? ` · ${c.code}` : ""}</div>;
  }
  const ph = digits(mq.whatsapp), em = String(mq.email || "").trim().toLowerCase();
  const dup = customers.find((c) => (ph.length >= 8 && [c.whatsapp, c.phone].some((p) => digits(p) === ph)) || (em && String(c.email || "").trim().toLowerCase() === em));
  if (dup) {
    return (
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="mq-cust-duplicate">
        <div className="flex items-start gap-2 min-w-0"><AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" /><span>Customer sudah terdaftar: <b>{dup.name}</b>{dup.code ? ` (${dup.code})` : ""} — nomor telepon / email sama.</span></div>
        <button type="button" data-testid="mq-cust-use-existing" onClick={() => onPick(dup.id)} className="self-start sm:self-auto shrink-0 px-2.5 py-1 rounded-md bg-amber-600 text-white font-medium hover:bg-amber-700">Pakai customer ini</button>
      </div>
    );
  }
  if (!mq.customer_name.trim()) return null;
  return (
    <div className="flex items-center justify-between gap-2 text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2" data-testid="mq-cust-new">
      <span>Customer baru — belum ada di CRM.</span>
      <button type="button" data-testid="mq-cust-add" onClick={onAdd} className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-slate-900 text-white font-medium hover:bg-slate-700"><UserPlus className="w-3.5 h-3.5" /> Tambah Customer</button>
    </div>
  );
};
